export default __webpack_public_path__ + "static/media/V4 - tarefas.60679c59.svg";